import { render, staticRenderFns } from "./ThongTinForm.vue?vue&type=template&id=01165376"
import script from "./ThongTinForm.vue?vue&type=script&lang=js"
export * from "./ThongTinForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports